import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { interval } from 'rxjs/observable/interval';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-voting-timer',
  templateUrl: 'voting-timer.html'
})

export class VotingTimerComponent implements OnInit, OnDestroy {

  constructor() { }

  public countdown: any;
  public countdownTime: number;

  @Input('time')
  public maxTime: any;

  @Input('config')
  public config: any;

  @Input('userHasRecord')
  public userHasRecord: boolean;

  @Output('blockVoting')
  public blockVoting: EventEmitter<boolean> = new EventEmitter();

  public intervalSubs: Subscription;

  ngOnInit() {
    if (!this.userHasRecord) {
      this.configureStartCoundown();
    }
  }

  public configureStartCoundown() {
    this.maxTime = parseInt(this.maxTime);
    this.startCountdown();
  }

  public startCountdown() {
    this.countdownTime = this.maxTime;
    this.blockVoting.emit(false);
    this.getCountdown(this.maxTime);
  }

  public getTimerValue() {
    return this.countdownTime;
  }

  public getCountdown(maxTime) {
    this.intervalSubs = interval(1000).subscribe((val) => {
      if (this.countdownTime == 0) {
        this.stopCountDown();
      } else {
        this.countdownTime -= 1;
      }
    })

  }

  public stopCountDown() {
    if (this.intervalSubs) this.intervalSubs.unsubscribe();
    this.blockVoting.emit(true);
  }

  ngOnDestroy() {
    this.stopCountDown();
  }

}


// WEBPACK FOOTER //
// ./src/pages/voting/components/voting-timer/voting-timer.ts